import React from 'react';
import Popup from '../common/components/Popup';
import PopupWarningContent from './PopupWarningContent';

interface deactivateUserPopupProps {
    showPopup: boolean,
    userId: string,
    email: string,
    userStatus: boolean,
    deactivateUser: (userId: string) => void,
    onClose: (show: boolean) => void,
}

function DeactivateUserPopup(props: deactivateUserPopupProps) {
    const {showPopup, userId, email, userStatus, 
        onClose, deactivateUser} = props;

    return (
        <Popup
            show={showPopup}
            onClose={() => onClose(false)}
            title={!userStatus ? 'Are you sure you want to activate de-activated user?' : 'Are you sure you want to de-activate user?'}
            size='lg'
            primaryCtaText={!userStatus ? 'Confirm activate' : 'Confirm de-activate'}
            primaryCtaOnClick={() => deactivateUser(userId)}
            secondaryCtaText='Cancel'
            secondaryCtaOnClick={() => onClose(false)}
            customClassName='manage-user-menu-popup'
        >
            <PopupWarningContent mainContent={!userStatus ?
                'The following user will be able to use the service':
                'The following user will not be able to use the service'} 
                subContent={email}/>
        </Popup>
    );
}

export default DeactivateUserPopup;
